import { useState } from "react";

export default function App() {
  const [topic, setTopic] = useState("");
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const generate = async () => {
    if (!topic.trim()) return alert("Please enter a topic");
    setLoading(true);
    setResult("");
    setError("");

    try {
      const res = await fetch("https://blog-generator-api-production.up.railway.app/generate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ topic }),
      });
      const data = await res.json();
      if (data.success) {
        setResult(data.result);
      } else {
        setError(data.error);
      }
    } catch (err) {
      setError("Could not connect to server. Make sure the API is running.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>

        {/* Header */}
        <h1 style={styles.title}>Specialized AI SEO Blog Generator</h1>
        <p style={styles.subtitle}>
          Enter a topic and get a fully researched, SEO-optimised blog post in seconds.
        </p>

        {/* Input */}
        <input
          style={styles.input}
          type="text"
          placeholder="e.g. How to use AI to grow a small business"
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && generate()}
          disabled={loading}
        />

        {/* Button */}
        <button
          style={loading ? { ...styles.button, ...styles.buttonDisabled } : styles.button}
          onClick={generate}
          disabled={loading}
        >
          {loading ? "Generating... this takes about 60 seconds ⏳" : "Generate Blog Post"}
        </button>

        {/* Error */}
        {error && <p style={styles.error}>❌ {error}</p>}

        {/* Result */}
        {result && (
          <div style={styles.resultBox}>
            <div style={styles.resultHeader}>
              <span>✅ Blog post generated!</span>
              <button
                style={styles.copyButton}
                onClick={() => navigator.clipboard.writeText(result)}
              >
                Copy
              </button>
            </div>
            <pre style={styles.resultText}>{result}</pre>
          </div>
        )}

      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    background: "#f1f5f9",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "60px 20px",
    fontFamily: "'Segoe UI', sans-serif",
  },
  card: {
    background: "#ffffff",
    borderRadius: 16,
    padding: "40px",
    width: "100%",
    maxWidth: 800,
    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
  },
  title: {
    fontSize: 32,
    fontWeight: 700,
    color: "#0f172a",
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 16,
    color: "#64748b",
    marginBottom: 24,
  },
  input: {
    width: "100%",
    padding: "14px 16px",
    fontSize: 16,
    border: "1.5px solid #e2e8f0",
    borderRadius: 10,
    marginBottom: 12,
    outline: "none",
    boxSizing: "border-box",
    color: "#0f172a",
  },
  button: {
    width: "100%",
    padding: "14px",
    fontSize: 16,
    fontWeight: 600,
    background: "#2563eb",
    color: "#ffffff",
    border: "none",
    borderRadius: 10,
    cursor: "pointer",
    marginBottom: 16,
  },
  buttonDisabled: {
    background: "#93c5fd",
    cursor: "not-allowed",
  },
  error: {
    color: "#ef4444",
    fontSize: 14,
    marginBottom: 16,
  },
  resultBox: {
    background: "#f8fafc",
    border: "1.5px solid #e2e8f0",
    borderRadius: 10,
    padding: 20,
    marginTop: 8,
  },
  resultHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
    fontSize: 14,
    fontWeight: 600,
    color: "#16a34a",
  },
  copyButton: {
    background: "#f1f5f9",
    border: "1px solid #e2e8f0",
    borderRadius: 6,
    padding: "4px 12px",
    fontSize: 13,
    cursor: "pointer",
    color: "#475569",
  },
  resultText: {
    whiteSpace: "pre-wrap",
    fontSize: 14,
    lineHeight: 1.7,
    color: "#334155",
    margin: 0,
  },
};